module.exports = __webpack_public_path__ + "static/media/view student skills.85854ae4.svg";